import { render, staticRenderFns } from "./LdGatedLink.vue?vue&type=template&id=b729b42c"
import script from "./LdGatedLink.vue?vue&type=script&lang=js"
export * from "./LdGatedLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports